import React, { useMemo, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    historyActions,
    storeActions,
    dynAct,
    getHistory,
} from '@src/ducks';
import { loginURL } from '@src/global/loginURL';
import {
    setAppHistory,
} from '@src/requests';
import { removeJwt } from '@src/utils/jwtHelpers';

import '@src/css/metlife_css/buttons.scss';

import styles from './error.scss';

import bootstrap from '@src/css/bootstrap.scss';

/**
 * Error401 - 401 error page
 */

const Error401 = () => {
    const dispatch = useDispatch();
    const history = useSelector(getHistory);

    const actions = useMemo(() => bindActionCreators({
        ...dynAct,
        ...storeActions,
        ...historyActions,
    }, dispatch), [dispatch]);

    const setLocalStorageToNoneAndRefreshPage = React.useCallback(() => {
        removeJwt();
        window.location.replace(loginURL());
    }, []);

    useEffect(() => {
        actions.appRequest(setAppHistory(history));
    }, [actions, history]);

    return (
        <div id="home" className={`col-12 ${styles.error_page}`}>
            <div className={bootstrap.container}>
                <div className={bootstrap.row}>
                    <div className={`${bootstrap.col} ${bootstrap['text-center']}`}>
                        <div className="error-container">
                            <h1>Your Producer News Portal session has ended</h1>
                            <p>For your security, sessions automatically end.</p>
                            <p className="pt-5">
                                <a className="ml-button-primary" tabIndex={0} onClick={setLocalStorageToNoneAndRefreshPage}>Log In Again</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error401;
